import { View } from 'react-native'

import { useTheme } from '~/hooks'

export function Divider() {
  const theme = useTheme()

  return (
    <View
      style={{
        width: '100%',
        height: 1,

        backgroundColor: theme.colorBorderNeutralDefault,
      }}
    />
  )
}
